import React, { useState } from "react";
import JoditEditor from "jodit-react";
import "./managejodit.css";
import { RiQuestionnaireFill } from "react-icons/ri";
import { FaTools } from "react-icons/fa";
import { toast } from "react-toastify";

const ManageJoditFaq = () => {
  const [question, setQuestion] = useState(""); // Initialize question state
  const [content, setContent] = useState(""); // Initialize content state with an empty string

  const handleSave = async () => {
    try {
      // Check if question or answer is empty
      if (!question.trim() || content.trim() === "<p><br></p>") {
        toast.error("Question or Answer is empty");
        return;
      }
      
  
      // Save the content to the server
      const response = await fetch("http://localhost:4002/faq-add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ question, answer: content }), // Include question and answer in the request body
      });
  
      if (!response.ok) {
        throw new Error("Failed to save content");
      }
      toast.success("Faq Added Successfully");
  
      const data = await response.json();
      setContent("")
      setQuestion("")
    } catch (error) {
      console.error("Error saving content:", error);
    }
  };
  

  const editorConfig = {
    readonly: false,
    editHTMLDocumentMode: true,
    uploader: {
      url: "http://localhost:4002/upload",
      filesVariableName: function (i) {
        return "image"; // Specify the correct field name
      },
      withCredentials: false,
      format: "json",
      method: "POST",
      prepareData: function (formData) {
        const file = formData.get("image");
        formData.set("image", file);
        return formData;
      },
      isSuccess: function (resp) {
        // Append the new image to the current content
        const newContent = `${content}<img src="${resp.imageUrl}" alt="Uploaded Image" />`;
        setContent(newContent);
        return !resp.error;
      },
      getMessage: function (resp) {
        return resp.msgs.join("\n");
      },
      process: function (resp) {
        return resp;
      },
    },
  };

  return (
    <div className="main container-fluid">
        <div className="h1 mb-4 mt-5 text-center text-dark d-flex  justify-content-center align-items-center">
        <FaTools  className="me-2"/>
        <span style={{ color: '#c21717' }}> Manage FAQ?</span>
      </div>
      {/* Question Section */}
      <div className="row d-flex justify-content-center">
        <div className="col-md-10">
          <strong style={{ fontSize: '1.2em' }}>Question <strong style={{ color: "#c21717" }}>*</strong></strong>
          <div className="input-group mb-3">
            <textarea className="form-control" value={question} placeholder="Enter your Question..." aria-label="Enter your text..." aria-describedby="basic-addon2" rows="4" onChange={(e) => setQuestion(e.target.value)}></textarea>
          </div>
        </div>
      </div>

      {/* Answer Section */}
      <div className="row d-flex justify-content-center">
        <div className="col-md-10">
          <strong style={{ fontSize: '1.2em' }}>Answer <strong style={{ color: "#c21717" }}>*</strong></strong>
          {/* Add your QuillToolbar component here */}
        </div>
      </div>

      {/* Quill Editor */}
      <div className="row d-flex justify-content-center">
        <div className="col-md-10">
          <JoditEditor
            value={content} // Pass the content state as the initial value
            config={editorConfig}
            tabIndex={1}
            onBlur={(newContent) => setContent(newContent)}
          />
        </div>
      </div>

      {/* Save Button */}
      <div className="row d-flex justify-content-center mt-4">
        <div className="col-md-10">
          <button className="btn btn w-100 text-white" style={{ background: "#c21717" }} onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default ManageJoditFaq;
